import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgGlobeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#GlobeIcon_svg__a)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm5.354-5.393c.088-.231.184-.454.287-.666A6.506 6.506 0 0 0 1.543 7.25h2.971c.067-1.777.368-3.399.84-4.643Zm.661 4.643c.066-1.627.344-3.062.742-4.11.23-.607.485-1.046.73-1.32.247-.274.421-.32.513-.32.092 0 .266.046.512.32s.501.713.731 1.32c.398 1.048.676 2.483.742 4.11h-3.97Zm3.97 1.5h-3.97c.066 1.627.344 3.062.742 4.11.23.607.485 1.046.73 1.32.247.274.421.32.513.32.092 0 .266-.046.512-.32s.501-.713.731-1.32c.398-1.048.676-2.483.742-4.11Zm1.501-1.5c-.067-1.777-.368-3.399-.84-4.643a7.912 7.912 0 0 0-.287-.666 6.506 6.506 0 0 1 4.098 5.309h-2.971Zm2.971 1.5h-2.971c-.067 1.777-.368 3.399-.84 4.643a7.918 7.918 0 0 1-.287.666 6.506 6.506 0 0 0 4.098-5.309Zm-9.943 0H1.543a6.506 6.506 0 0 0 4.098 5.309 7.921 7.921 0 0 1-.287-.666c-.472-1.244-.773-2.866-.84-4.643Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="GlobeIcon_svg__a">
          <path fill="#fff" d="M0 16h16V0H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const GlobeIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgGlobeIcon} />;
});
GlobeIcon.displayName = 'GlobeIcon';
export default GlobeIcon;
